export default "__VITE_ASSET__BGAnS6gQ__"